import { calendarGridSkeletonStyles } from '@/app/(main)/calendar/components/CalendarPanel/styles';
import type { CalendarPanelProps } from '@/app/(main)/calendar/components/CalendarPanel/types';
import { cn } from '@/utils/сn';

type CalendarGridSkeletonProps = {
  variant: CalendarPanelProps['variant'];
};

function SkeletonBar({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded bg-grey-200', className)} aria-hidden />;
}

const TIME_SLOT_LABELS = ['7am', '9am', '11am', '1pm', '3pm', '5pm', '7pm'];

export function CalendarGridSkeleton({ variant }: CalendarGridSkeletonProps) {
  return (
    <div
      className={calendarGridSkeletonStyles({ variant })}
      aria-busy
      aria-label="Loading calendar"
    >
      <SkeletonBar className="h-11 shrink-0 rounded-none" />

      <div className="flex shrink-0 border-b border-grey-300 px-4 py-3">
        <SkeletonBar className="h-4 w-16" />
      </div>

      <div className="flex min-h-0 flex-1">
        <div className="flex w-14 shrink-0 flex-col border-r border-grey-300 py-2">
          {TIME_SLOT_LABELS.map((label) => (
            <div key={label} className="flex h-16 items-start justify-end pr-2 pt-1">
              <SkeletonBar className="h-3 w-8" />
            </div>
          ))}
        </div>

        <div className="relative min-h-0 flex-1">
          {TIME_SLOT_LABELS.map((label, index) => (
            <div
              key={`${label}-row`}
              className={cn('absolute inset-x-0 border-t border-grey-200', index === 0 && 'border-t-grey-300')}
              style={{ top: `${(index / TIME_SLOT_LABELS.length) * 100}%` }}
            />
          ))}
          <SkeletonBar className="absolute left-4 top-[18%] h-10 w-[55%] rounded-md" />
          <SkeletonBar className="absolute left-4 top-[42%] h-14 w-[40%] rounded-md" />
        </div>
      </div>
    </div>
  );
}
